import {
  personComparison,
  validatePersonContacts,
} from "../../../../../../../_shared/_logic/contact-comparison"
import type {
  WrongRecipientReplacementRow,
  WrongRecipientReplacementDraft,
} from "../../../contract"
export const editorReason = (
  row: WrongRecipientReplacementRow,
  draft: WrongRecipientReplacementDraft,
): string | null =>
  !row.needsStep
    ? "Diese Zeile ist bereits abgeschlossen."
    : draft.action !== "replace"
      ? "Die Zuordnung wird entfernt; neue Angaben werden nicht übernommen."
      : null
export const validateDraft = (
  _row: WrongRecipientReplacementRow,
  draft: WrongRecipientReplacementDraft,
): string | null => {
  if (!draft.action) return "Bitte wählen Sie eine Empfänger-Entscheidung aus."

  if (draft.action === "remove") return null

  if (!draft.displayName.trim() || !draft.role)
    return "Bitte tragen Sie Name und Rolle für die neue Zuordnung ein."

  return validatePersonContacts(draft)
}
export const previousComparisons = (row: WrongRecipientReplacementRow) => [
  personComparison({
    side: "Bisheriger Ansprechpartner",
    displayName: row.customerLabel,
    role: row.roleLabel,
    email: row.customerEmail,
    phone: row.customerPhone,
    unit: `${row.addressLabel} · ${row.unitLabel}`,
  }),
]
export const comparison = (
  row: WrongRecipientReplacementRow,
  draft: WrongRecipientReplacementDraft,
) =>
  personComparison({
    ...draft,
    side: "Neuer Ansprechpartner",
    unit: `${row.addressLabel} · ${row.unitLabel}`,
    origin: row.sourceLabel,
    original: Object.values(draft.fieldMeta)
      .map((meta) => meta.initialValue)
      .filter(Boolean)
      .join(" · "),
    state: row.isResolved
      ? "Gespeichertes Ergebnis"
      : Object.values(draft.fieldMeta).some((meta) => meta.currentSource === "manual")
        ? "Manuell korrigierter Entwurf"
        : "Übernahmeentwurf",
    hint: draft.action === "remove" ? "Zuordnung wird entfernt" : undefined,
  })
